import { Directive, HostListener } from '@angular/core';
import { NbLayoutScrollService, NbStepperComponent } from '@nebular/theme';

const MOBILE_MAX_WIDTH = 767;

/**
 * Picked up automatically by every `nbStepperNext` / `nbStepperPrevious` button.
 *
 * On phones, once the stepper has actually moved to another step, it scrolls the page back to
 * the top. Centring the selected step in the stepper header is handled by
 * StepperCenterStepDirective, which reacts to any change of the selected step.
 */
@Directive({
  selector: '[nbStepperNext], [nbStepperPrevious]',
})
export class StepperScrollTopDirective {

  private indexBeforeClick: number;

  constructor(private stepper: NbStepperComponent,
              private scrollService: NbLayoutScrollService) {
  }

  // These fire before `click`, so they see the step that was active before Nebular moves it
  @HostListener('mousedown')
  @HostListener('touchstart')
  @HostListener('keydown')
  rememberCurrentStep() {
    this.indexBeforeClick = this.stepper.selectedIndex;
  }

  @HostListener('click')
  onClick() {
    if (window.innerWidth > MOBILE_MAX_WIDTH) {
      return;
    }
    const before = this.indexBeforeClick;
    this.indexBeforeClick = undefined;

    // Let Nebular switch the step and render the new content first
    setTimeout(() => {
      // Nothing moved (e.g. the current form is invalid) - keep the user where they are
      if (before !== undefined && before === this.stepper.selectedIndex) {
        return;
      }
      this.scrollService.scrollTo(0, 0);
    });
  }
}
